import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import ReactStackedBarCharts from "components/CustomChart/ReactStackedBarCharts.jsx";
import PolarRadialBarCharts from "components/CustomChart/PolarRadialBar.jsx";
import BasicColumn from "components/CustomChart/BasicColumn.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import TextField from '@material-ui/core/TextField';

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

class PageW extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container + " fullWidth"}>
        <GridContainer justify="center" spacing={5}>
          <GridItem xs={12}>
            {/* <BasicColumn/>
              <ReactStackedBarCharts/> */}
            <PolarRadialBarCharts />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(PageW);
